import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Error from 'bdvp-common/src/components/Error';
import { Tracking } from 'bdvp-tracking';

const ErrorMsg = ({ error }) => {

    useEffect(() => {

        console.error(`${error.name}: ${error.message}`);
        Tracking.trackAppRuntimeError();

    }, []);

    return (
        <Error />
    );

};

ErrorMsg.propTypes = {
    error: PropTypes.shape({
        name: PropTypes.string,
        message: PropTypes.string,
    }),
};

ErrorMsg.defaultProps = {
    error: {
        name: 'Error',
        message: 'Runtime Error',
    },
};

export default ErrorMsg;